{
  "required": "Requerido",
  "invalidEmail": "El formato del correo electrónico es invalido",
  "invalidPhoneNumber": "El formato del número de teléfono no es válido",
  "email-kind-invalid": "Tipo no válido para un Email",
  "invalid-uppercase": "No se permiten mayúsculas"
}
